import permissions from './permissions';
import AclManager from 'universal-permissions';
import { userTypes, userTypeRoles } from '../../constants/user';

/**
 * AccessControl
 */
class AccessControl {

  /**
   * @property {object} store
   */
  store = null;

  /**
   * @property {object} aclManager
   */
  aclManager = null;

  /**
   * AccessControl initialization
   * 
   * @param {object} store 
   */
  init(store) {
    this.store = store;
    this.aclManager = new AclManager(permissions);
  }

  /**
   * Check access control is ready
   *
   * @returns {boolean}
   */
  isReady() {
    const { authUser } = this.store.getState();

    return this.store && !authUser.get('isLoading');
  }

  /**
   * Check user authorization
   *
   * @returns {boolean}
   */
  isAuthentificated() {
    const { authUser } = this.store.getState();

    return !!authUser.get('userId');
  }

  /**
   * Check user has roles
   * 
   * @param {string} type 
   * @param {string} role 
   * @param {number} membershipId
   * 
   * @returns {boolean}
   */
  hasRole(type, role = null, membershipId = null) {
    
    if (this.store === null) {
      throw new Error('You must call \'init\' before use this method.');
    }

    const { authUser } = this.store.getState();

    if (!userTypes.hasOwnProperty(type) || authUser.get('userType') !== userTypes[type]) {
      return false;
    }

    if (role !== null && !membershipId) {
      if (!userTypeRoles[type].hasOwnProperty(role)) {
        return false;
      }
      
      const memberships = authUser.get('schoolMembership')
        .filter(membership => membership.get('role') === userTypeRoles[type][role]);

      if (memberships.size === 0) {
        return false;
      }
    }

    if (membershipId) {
      const membership = authUser.get('schoolMembership')
        .find(membership => membership.get('schoolId') === membershipId);

      if (!membership || (role !== null && membership.get('role') !== userTypeRoles[type][role])) {
        return false;
      }
    }

    return true;
  }

  /**
   * Check user access permissions
   *
   * @param {string} permission
   * @param {string} accessScope
   * @param {object|null} target object for which needed to check permissions
   * @returns {boolean}
   */
  can(permission, accessScope, target = null) {
    if (this.aclManager === null || this.store === null) {
      throw new Error('You must call \'init\' before use this method.');
    }

    const { authUser } = this.store.getState();
    
    return target === null
      ? this.aclManager.can(authUser.toJS(), permission, accessScope)
      : this.aclManager.can(authUser.toJS(), permission, { [accessScope]: target });
  }
}

export default new AccessControl();


// WEBPACK FOOTER //
// ./src/services/access-control/access-control.js